import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Association from "@/pages/association/page";
import Actions from "@/pages/actions/page";
import ActionDetail from "@/pages/actions/detail/page";
import Realisations from "@/pages/realisations/page";
import Contact from "@/pages/contact/page";
import Don from "@/pages/don/page";
import MentionsLegales from "@/pages/mentions-legales/page";
import PolitiqueConfidentialite from "@/pages/politique-de-confidentialite/page";
import Login from "@/pages/auth/login/page";
import Register from "@/pages/auth/register/page";
import AuthCallback from "@/pages/auth/callback/page";
import ForgotPassword from "@/pages/auth/forgot-password/page";
import ResetPassword from "@/pages/auth/reset-password/page";
import AdminGuard from "@/pages/admin/components/AdminGuard";
import AdminLayout from "@/pages/admin/components/AdminLayout";
import AdminDashboard from "@/pages/admin/dashboard/page";
import AdminParametres from "@/pages/admin/parametres/page";
import AdminIndicateurs from "@/pages/admin/indicateurs/page";
import AdminMissions from "@/pages/admin/missions/page";
import AdminArguments from "@/pages/admin/arguments/page";
import AdminEquipe from "@/pages/admin/equipe/page";
import AdminHistorique from "@/pages/admin/historique/page";
import AdminValeurs from "@/pages/admin/valeurs/page";
import AdminMission from "@/pages/admin/mission/page";
import AdminActions from "@/pages/admin/actions/page";
import AdminRealisations from "@/pages/admin/realisations/page";
import AdminFaq from "@/pages/admin/faq/page";
import AdminDons from "@/pages/admin/dons/page";
import AdminMembres from "@/pages/admin/membres/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/association",
    element: <Association />,
  },
  {
    path: "/actions",
    element: <Actions />,
  },
  {
    path: "/actions/:slug",
    element: <ActionDetail />,
  },
  {
    path: "/realisations",
    element: <Realisations />,
  },
  {
    path: "/don",
    element: <Don />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/politique-de-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/register",
    element: <Register />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/auth/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/auth/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/admin",
    element: (
      <AdminGuard>
        <AdminLayout />
      </AdminGuard>
    ),
    children: [
      {
        index: true,
        element: <AdminDashboard />,
      },
      {
        path: "parametres",
        element: <AdminParametres />,
      },
      {
        path: "indicateurs",
        element: <AdminIndicateurs />,
      },
      {
        path: "missions",
        element: <AdminMissions />,
      },
      {
        path: "arguments",
        element: <AdminArguments />,
      },
      {
        path: "equipe",
        element: <AdminEquipe />,
      },
      {
        path: "historique",
        element: <AdminHistorique />,
      },
      {
        path: "valeurs",
        element: <AdminValeurs />,
      },
      {
        path: "mission",
        element: <AdminMission />,
      },
      {
        path: "actions",
        element: <AdminActions />,
      },
      {
        path: "realisations",
        element: <AdminRealisations />,
      },
      {
        path: "faq",
        element: <AdminFaq />,
      },
      {
        path: "dons",
        element: <AdminDons />,
      },
      {
        path: "membres",
        element: <AdminMembres />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;